import Me from '@models/Me';
import { useSelector } from 'react-redux';
import { subscriptionTypes } from '../constants';

const useSubscriptionExpired = (goalUID, subscriptionType) => {
  const me = useSelector(({ auth }) => auth.me);
  if (subscriptionType === subscriptionTypes.ICONIC)
    return Me.hasExpiredIconicSubscriptionToGoal(me, goalUID);
  if (subscriptionType === subscriptionTypes.ICONIC_PRO)
    return Me.hasExpiredIconicProSubscriptionToGoal(me, goalUID);
  return Me.hasExpiredSubscriptionToGoal(me, goalUID);
};

export default useSubscriptionExpired;
